import React, { memo } from 'react';

import Stack from '@mui/material/Stack';

import { preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import { useAppSelector } from 'hooks/redux';

import TopBarHelpMenu from './TopBarHelpMenu';
import TopBarAIButton from './TopBarAIButton';
import TopBarNotifications from './TopBarNotifications';
import TopBarProfileMenu from './TopBarProfileMenu';
import TopBarSettings from './TopBarSettings';

const TopBarNavItems = memo(function TopBarNavItems() {
  const hideNavButtons = useAppSelector(
    (state) => preferencesV2Selectors.getPreferenceValue(state, 'gsfScreen', 'completed_gsf') !== 'completed_gsf',
  );

  return (
    <Stack
      id='topbar-nav-items'
      direction='row'
      gap={1}
      alignItems='center'
      justifyContent='flex-end'
      sx={{ flexShrink: 0 }}
    >
      <TopBarAIButton id='topbar-nav-ai-button' />
      {!hideNavButtons && <TopBarNotifications id='topbar-nav-notifications' />}
      <TopBarHelpMenu id='topbar-nav-help-menu' hideNavButtons={!hideNavButtons} />
      {!hideNavButtons && <TopBarSettings id='topbar-nav-settings' />}
      <TopBarProfileMenu id='topbar-nav-profile-menu' hideFeatures={hideNavButtons} />
    </Stack>
  );
});

export default TopBarNavItems;
